// 统一 API 错误处理函数
// 使用方式： this.$handleApiError(err) or import { handleApiError } from '@/utils/handleApiError'
import { ElMessage } from 'element-plus';

export function extractErrorMessage(error) {
  if (!error) return '未知错误';
  // 优先 err.message（拦截器已覆盖）
  const msg = error.message || error.msg || error.error;
  if (msg) return msg;
  // 兼容各种结构
  return (
    error?.response?.data?.message ||
    error?.response?.data?.Message ||
    error?.data?.message ||
    error?.data?.Message ||
    '操作失败'
  );
}

export function handleApiError(error, options = {}) {
  const { silent = false } = options;
  const message = extractErrorMessage(error);
  if (!silent) {
    ElMessage.error(message);
  }
  return message;
}

export default handleApiError;
